// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M2.10156 7.16016L10.2665 12.8756C10.9277 13.3384 11.2582 13.5698 11.6178 13.6595C11.9355 13.7386 12.2677 13.7386 12.5853 13.6595C12.9449 13.5698 13.2755 13.3384 13.9366 12.8756L22.1016 7.16016M6.90156 20.1602H17.3016C18.9817 20.1602 19.8218 20.1602 20.4635 19.8332C21.028 19.5456 21.487 19.0866 21.7746 18.5221C22.1016 17.8804 22.1016 17.0403 22.1016 15.3602V8.96016C22.1016 7.28 22.1016 6.43992 21.7746 5.79818C21.487 5.2337 21.028 4.77476 20.4635 4.48714C19.8218 4.16016 18.9817 4.16016 17.3016 4.16016H6.90156C5.22141 4.16016 4.38133 4.16016 3.73959 4.48714C3.1751 4.77476 2.71616 5.2337 2.42854 5.79818C2.10156 6.43992 2.10156 7.28 2.10156 8.96016V15.3602C2.10156 17.0403 2.10156 17.8804 2.42854 18.5221C2.71616 19.0866 3.1751 19.5456 3.73959 19.8332C4.38133 20.1602 5.22141 20.1602 6.90156 20.1602Z"
    />
  </svg>
);
const IconEnvelopeCloseOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconEnvelopeCloseOutline;
